/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartsDto } from './partsDto';


export interface UploadedPartsDto { 
    parts: Array<PartsDto>;
    nextPartNumberMarker: number;
    uploadId: string;
}

